import { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AdminNavBar from "../../NavBar/AdminNavBar";
import style from './createPayroll.module.css'

export default function CreatePayroll() {

    const navigate = useNavigate();
    const { adminId, employeeId } = useParams();
    const apiUrl = process.env.REACT_APP_SERVER_URL;
    const token = localStorage.getItem("token");

    const [payroll, setPayroll] = useState({
        employeeId: employeeId, // employee receiving payroll
        createdBy: adminId,     // admin creating payroll
        baseSalary: "",
        bonus: "",
        allowances: "",
        deductions: "",
        grossSalary: 0,
        netSalary: 0,
        notes: "",
        paymentMethod: "Bank Transfer",
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        let updated = { ...payroll, [name]: value };

        // Auto-calculate gross/net salary
        if (["baseSalary", "bonus", "allowances", "deductions"].includes(name)) {
            const base = parseFloat(updated.baseSalary) || 0;
            const bonus = parseFloat(updated.bonus) || 0;
            const allowances = parseFloat(updated.allowances) || 0;
            const deductions = parseFloat(updated.deductions) || 0;

            updated.grossSalary = base + bonus + allowances;
            updated.netSalary = updated.grossSalary - deductions;
        }

        setPayroll(updated);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch(`${apiUrl}/payroll/create-payroll/${employeeId}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(payroll),
            });

            const data = await res.json();

            if (res.ok) {
                alert("Payroll created successfully!");
                navigate(`/admin-dashboard/${adminId}/all-payrolls`);
            } else {
                alert("Error: " + data.message);
            }
        } catch (err) {
            alert("Failed to create payroll: " + err.message);
        }
    };


    return (
        <>
            <AdminNavBar />
            <div className={style.payrollPage}>
                <div className="container   ">
                    <div className="mt-4 ps-3 pb-4">
                        <span>
                            <Link
                                to={`/admin-dashboard/${employeeId}`} style={{ textDecoration: 'none' }}>
                                Dashboard
                                <i className="ps-1 pe-1 bi bi-caret-right-fill"></i>
                            </Link>
                        </span>
                        <span>
                            <Link to={`/admin-dashboard/${employeeId}/all-payrolls`} style={{ textDecoration: 'none' }}>
                                All Payrolls
                                <i className="ps-1 pe-1 bi bi-caret-right-fill"></i>
                            </Link>
                        </span>
                        <span>
                            <Link
                                to={`/admin-dashboard/${adminId}/payroll/create-payroll/${employeeId}`}
                                style={{ textDecoration: 'none' }}
                            >
                                Create Payroll for {employeeId}
                            </Link>
                        </span>
                    </div>
                    <div className="card shadow-lg border-0 rounded-4">
                        <div className="card-body p-4">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    {/* Employee ID */}
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Employee ID</label>
                                        <input
                                            type="text"
                                            name="employeeId"
                                            value={payroll.employeeId}
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="Employee ID for payroll"
                                            required
                                        />
                                    </div>

                                    {/* Created By (auto) */}
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Created By</label>
                                        <input
                                            type="text"
                                            name="createdBy"
                                            value={payroll.createdBy}
                                            className="form-control bg-light"
                                            readOnly
                                        />
                                    </div>

                                    {/* Salary fields */}
                                    <div className="col-md-3">
                                        <label className="form-label fw-bold">Base Salary</label>
                                        <input
                                            type="number"
                                            name="baseSalary"
                                            value={payroll.baseSalary}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label fw-bold">Bonus</label>
                                        <input
                                            type="number"
                                            name="bonus"
                                            value={payroll.bonus}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label fw-bold">Allowances</label>
                                        <input
                                            type="number"
                                            name="allowances"
                                            value={payroll.allowances}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label fw-bold">Deductions</label>
                                        <input
                                            type="number"
                                            name="deductions"
                                            value={payroll.deductions}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                    </div>

                                    {/* Auto-calculated */}
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Gross Salary</label>
                                        <input
                                            type="number"
                                            value={payroll.grossSalary}
                                            className="form-control bg-light"
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Net Salary</label>
                                        <input
                                            type="number"
                                            value={payroll.netSalary}
                                            className="form-control bg-light"
                                            readOnly
                                        />
                                    </div>


                                </div>
                                <div className="row mt-lg-4">

                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Notes</label>
                                        <textarea
                                            name="notes"
                                            value={payroll.notes}
                                            onChange={handleChange}
                                            className="form-control"
                                            rows={2}
                                            placeholder="Any remarks"
                                        />
                                    </div>
                                    {/* Notes & Payment */}
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Payment Method</label>
                                        <select
                                            name="paymentMethod"
                                            value={payroll.paymentMethod}
                                            onChange={handleChange}
                                            className="form-select"
                                        >
                                            <option value="Bank Transfer">Bank Transfer</option>
                                            <option value="Cash">Cash</option>
                                            <option value="Cheque">Cheque</option>
                                            <option value="UPI">UPI</option>
                                        </select>
                                    </div>
                                </div>


                                <div className="text-center mt-4">
                                    <button type="submit" className="btn btn-success px-5 py-2 rounded-3">
                                        ✅ Create Payroll
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
}
